module.exports = __webpack_public_path__ + "media/images/beach-3-712cf394.jpg";